// extracted by mini-css-extract-plugin
export var addressFields = "_nx-0";
export var animationContainer = "_nx-1";
export var footer = "_nx-2";
export var lineItems = "_nx-3";
export var modalContent = "_nx-4";
export var orderName = "_nx-5";
export var strong = "_nx-6";
export var warning = "_nx-7";